import React from 'react';
import { Spinner } from 'native-base';
import { useGeneralStyles } from './styles';
import { useSpringBigStore } from '@springbig/shared';

const ButtonSpinner = () => {


    const gStyle = useGeneralStyles();

    return (
        <Spinner
            size='lg'
            accessibilityLabel="Loading Submit"
            color={gStyle.button_text}
        />
    );
};

export default ButtonSpinner;
